/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FormData } from "./formConfig";

export enum NotificationGroupField {
  DETAILS = "details",
  CHANNELS = "channels",
}

export type NotificationGroupData = {
  [NotificationGroupField.DETAILS]: FormData | undefined;
  [NotificationGroupField.CHANNELS]: FormData | undefined;
};
export const defaultValues: NotificationGroupData = {
  [NotificationGroupField.DETAILS]: undefined,
  [NotificationGroupField.CHANNELS]: undefined,
};
